import { render, staticRenderFns } from "./InclusionSegmentsConfiguration.vue?vue&type=template&id=63bef19e"
import script from "./InclusionSegmentsConfiguration.vue?vue&type=script&lang=js"
export * from "./InclusionSegmentsConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports